import { createFileRoute } from '@tanstack/react-router';
import { qualityQuery } from '@/features/quality/api';
import { QualityPage } from '@/features/quality/pages/QualityPage';
import { qualitySearchSchema } from '@/features/quality/search';
import { sourcesQuery } from '@/features/sources/api';

export const Route = createFileRoute('/_authed/ops/quality/')({
  validateSearch: qualitySearchSchema,
  loaderDeps: ({ search: { days, source } }) => ({ days, source }),
  loader: ({ context: { queryClient }, deps }) => {
    void queryClient.prefetchQuery(qualityQuery(deps.days, deps.source));
    void queryClient.prefetchQuery(sourcesQuery());
  },
  component: QualityPage,
  staticData: { help: 'quality' },
});
